export default {
  login: "Anubhav2907",
  id: 76243969,
  node_id: "MDQ6VXNlcjc2MjQzOTY5",
  avatar_url: "https://avatars.githubusercontent.com/u/76243969?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/Anubhav2907",
  html_url: "https://github.com/Anubhav2907",
  followers_url: "https://api.github.com/users/Anubhav2907/followers",
  following_url:
    "https://api.github.com/users/Anubhav2907/following{/other_user}",
  gists_url: "https://api.github.com/users/Anubhav2907/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/Anubhav2907/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/Anubhav2907/subscriptions",
  organizations_url: "https://api.github.com/users/Anubhav2907/orgs",
  repos_url: "https://api.github.com/users/Anubhav2907/repos",
  events_url: "https://api.github.com/users/Anubhav2907/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/Anubhav2907/received_events",
  type: "User",
  site_admin: false,
  name: "Anubhav Singh",
  company: "NIT Surat",
  blog: "https://anxbhxv.tech/",
  location: "Surat, Gujarat",
  email: null,
  hireable: true,
  bio: "Hi there, I'm Anubhav. Trying to resolve undocumented features (ping me, I'll explain to you what that means).",
  twitter_username: "Anubhav18689129",
  public_repos: 22,
  public_gists: 0,
  followers: 6,
  following: 6,
  created_at: "2020-12-19T08:33:43Z",
  updated_at: "2021-05-28T15:07:39Z",
};
